import React, {useEffect, useRef, useState} from "react";
import Draggable from 'react-draggable';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
// Auth0
import { useAuth0 } from '../../auth0/auth0';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Launch from '@material-ui/icons/Launch';
import LoginIcon from "@material-ui/icons/ExitToApp";
//import * as CmsActions from '../actions/CmsActions';
import Stories from './Stories.jsx';
import Datasets from "./Datasets.jsx";
import TopMenu from "./TopMenu.jsx";
//import Models from "../containers/Models.jsx";
//import MyGlobeIcon from '../components/MyGlobeIcon';
import Layers from "./Layers.jsx";

//import Visualisation from "../containers/Visualisation.jsx";
//import ActionFooter from "../containers/ActionFooter.jsx";

const VisContainer = styled.section`
    padding:1.5rem;
    h2 {
        font-size:1.25rem;
        font-weight:500;
    }
`;
const dockAnimTime = 200;
const minimAnimTime = 200;
//const styles = theme => ({
const useStyles = makeStyles(theme => ({
    dragContainer: {
        zIndex: 70,
        position: 'absolute',
        width: '40rem',
        height: 'auto',
        '&.docked': {
            overflow: "hidden",
            width: '27rem',
            fontSize: '.75rem',
        },
        '&.animating': {
            transition: 'transform ease-in ' + dockAnimTime + 'ms',//TODO: improve anims to look nicer with width change
        },
        '&.minimising': {
            transition: 'transform ease-out ' + minimAnimTime + 'ms',
        }
    },
    fakeHidden: {
        visibility:'hidden',
        height: 0,
    },
    paper: {
        opacity:1,
        transform:'scale(1)',
        transition:'all '+minimAnimTime+'ms ease-out',
        transformOrigin:'top right',
    },
    minimising: {
        opacity:0,
        transform:'scale(.2)',
        transition:'all '+minimAnimTime+'ms ease-out',
        transformOrigin:'top right',
    },
    appbar: {
        background: theme.palette.primary[700],
    },
    flex: {
        flex: 1,
    },
    toolbarTitle: {
        display: "flex",
        flex: "50%",
        flexDirection: "column",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-start"
    },
    toolbarActions: {
        display: "flex",
        flex: "50%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    tabs: {
        background: theme.palette.primary[500],
    },
    hidden: {
        display:'none'
    },
    moveCursor: {
        cursor: 'move',
    },
    docker: {
        transform: 'rotate(90deg)',
        color: '#FFF',
        display: "flex",
        textAlign: "right",
    },
    undocker: {
        transform: 'rotate(-90deg)',
        color: '#FFF',
        display: "flex",
        textAlign: "right",
    },
    user: {
        color: theme.palette.common.black,
        background: theme.palette.common.white,
        fontWeight: "bold"
    }
}));

const Dashboard = (props) =>  {

    const dash = useRef(null);

    const classes = useStyles();
    const [globeName, setGlobeName] = useState("Dashboard");
    const [docked, setDocked] = useState(false);
    const [minimised, setMinimised] = useState(false);
    const [minimising, setMinimising] = useState(false);
    const [maximising, setMaximising] = useState(false);
    const [pos, setPos] = useState({ x: 0, y: 0 });
    const [oldPos, setOldPos] = useState({ x: 0, y: 0});
    const [screenDimensions, setScreenDimensions] = useState({screenW: 0, screenH: 0});
    const [animating, setAnimating] = useState(false);
    const [datasetsComp, setDatasetsComp] = useState(null);
    const [visLayersComp, setVisLayersComp] = useState(null);
    const [storiesComp, setStoriesComp] = useState(null);
    const [appState, setAppState] = useState("VISLAYERS");
    const [visLayers, setVisLayers] = useState(props.visLayers);
    const [datasets, setDatasets] = useState(props.datasets);
    const { isAuthenticated, loginWithPopup, loginWithRedirect, logout, loading, user } = useAuth0();
    const handleLogout = () => {
        logout({ returnTo: window.location.protocol + '//' + window.location.host });
    };

    useEffect(()=>{
        updateWindowDimensions();
        window.addEventListener('resize', updateWindowDimensions);
    }, []);

    /*componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }*/

    useEffect(() => {
        setVisLayers(props.visLayers);
        setDatasets(props.datasets);
        setVisLayersComp(<Layers isDocked={docked} handleSorted={props.handleSorted} visLayers={props.visLayers} handleDelete={props.handleDeleteVisLayer} handleLayerToggle={props.handleLayerToggle} handleSave={props.handleSave} handleStyle={props.handleStyle}/>);
        setDatasetsComp(<Datasets datasets={props.datasets} handleDelete={props.handleDeleteDataset} handleLoadDataset={props.handleLoadDataset}/>);
        setStoriesComp(<Stories stories={props.stories} handleDelete={props.handleDeleteStory} handleSave={props.handleSaveStory}/>)
    }, [props.visLayers, props.datasets])

    //TODO: Move this to the store so entire app can use?
    function updateWindowDimensions () {
        setScreenDimensions({screenW: window.innerWidth, screenH: window.innerHeight})
    }

    function handleChange (evt, value) {
        setAppState(value);
        //this.props.dispatch(CmsActions.changeAppState(value));
    };

    function toggleMenu (evt, value) {
        if(!minimising && !maximising) {
            if(!minimised) {
                setOldPos({ x: pos.x, y: pos.y });
                setPos({ x: screenDimensions.screenW - dash.current.clientWidth, y: 0});
                setMinimising(true);
                //this.setState({ oldPos:{x:this.state.pos.x,y:this.state.pos.y}, pos: { x: this.state.screenW - this.dash.clientWidth, y: 0 }, minimising:true });
                setTimeout(() => {
                    setMinimised(true);
                    setMinimising(false);
                }, minimAnimTime);
            } else {
                setMinimised(false);
                setMaximising(true);
                setPos({ x: oldPos.x, y: oldPos.y })
                //this.setState({ minimised: false, maximising:true, pos: {x:this.state.oldPos.x,y:this.state.oldPos.y} });
                setTimeout(() => {
                    setMinimised(false);
                    setMaximising(false);
                    //this.setState({ minimised: false, maximising:false });
                }, minimAnimTime);
            }
        }
    };
   function handleDocking() {
        //^lol
        if (!animating) {
            setAnimating(true);
            setTimeout(() => {
                setAnimating(false);
            }, dockAnimTime);
            setDocked(!docked);
            /*this.setState({ docked: !this.state.docked }, () => {
                if (this.state.docked && this.props.appState !== CmsActions.APP_STATES.LAYERS)
                    this.props.dispatch(CmsActions.changeAppState(CmsActions.APP_STATES.LAYERS));
                if (this.state.docked) {
                    this.setState({ oldPos:{x:this.state.pos.x,y:this.state.pos.y}, pos: { x: this.state.screenW - this.dash.clientWidth, y: this.state.screenH - this.dash.clientHeight } });
                } else {
                    //this.setState({ oldPos:{x:this.state.pos.x,y:this.state.pos.y} });
                    this.setState({ pos: {x:this.state.oldPos.x,y:this.state.oldPos.y} });
                }
            });*/

        }
    }
    function handleDragStop (evt, pos) {
        const { x, y } = pos;
        setPos({ x, y })
        //this.setState({ pos: { x, y } });
    }


    return (
        <div>
            <TopMenu handleMenuClick={toggleMenu} />
            <Draggable
                handle=".dragHandle"
                bounds="body"
                position={{ x: pos.x, y: pos.y }}
                //onStart={this.handleDragStart}
                //onDrag={this.handleDrag}
                onStop={handleDragStop}
            ><div className={classes.dragContainer+
                ' ' + (minimised ? classes.fakeHidden : "")
                + ' ' + (minimising||maximising ? 'minimising' : "")
                + ' ' + (animating ? 'animating' : "")
                + ' ' + (docked ? 'docked' : "")
            }>
                <Paper className={classes.paper + ' '+((minimising || minimised) ? classes.minimising : "")} elevation={8}>
                    <div ref={dash}>
                        <AppBar position="static" className={classes.appbar}>
                            <Toolbar className={classes.moveCursor + " dragHandle"}>
                                <Typography variant="title" color="inherit" className={classes.flex + ' ' + classes.toolbarTitle}>
                                    {globeName}
                                </Typography>
                                {/* <MyGlobeIcon /> */}
                                {isAuthenticated && user &&<div className={classes.toolbarActions}>
                                    <Chip className={classes.user} 
                                    avatar={<Avatar alt={user.nickname} src={user.picture} />}
                                    label={user.name}/>
                                    <IconButton onClick={handleLogout}><LoginIcon /></IconButton>
                                    <IconButton className={docked ? classes.undocker : classes.docker} onClick={handleDocking}><Launch /></IconButton>
                                </div>}
                                {!isAuthenticated&&<Button size="small" startIcon={<LoginIcon />} color="secondary" variant="contained" onClick={() => loginWithPopup({})}>Login</Button>}
                            </Toolbar>

                            {isAuthenticated && user &&<Tabs value={appState} onChange={handleChange} className={classes.tabs + (docked ? " " + classes.hidden : "")}>                                
                                <Tab value={"VISLAYERS"} label="VIS LAYERS" className={classes.flex} />
                                <Tab value={"DATASETS"} label="DATASETS" className={classes.flex} />
                                <Tab value={"STORIES"} label="STORIES" className={classes.flex} />                                
                            </Tabs>}
                        </AppBar>
                        <VisContainer>
                            {isAuthenticated && user ? <><div style={{display:appState === "VISLAYERS"?'block':'none'}}>{visLayersComp}</div>
                            <div style={{display:appState === "DATASETS"?'block':'none'}}>{datasetsComp}</div>
                            <div style={{display:appState === "STORIES"?'block':'none'}}>{storiesComp}</div>
                            {
                                //<div style={{display:this.props.appState === CmsActions.APP_STATES.VISUALISATION?'block':'none'}}>{this.state.vislayersComp}</div>
                                //<div style={{display:this.props.appState === CmsActions.APP_STATES.MODEL?'block':'none'}}>{this.state.modelsComp}</div>
                            }
                            </>:<div><p>Please log in to begin</p></div>}
                        </VisContainer>
                    </div>
                </Paper>
                </div>
            </Draggable>
        </div>
    );
}

/*const mapStateToProps = (store) => {
    return {
        loggedIn: store.cmsReducers.loggedIn,
        authenticating: store.cmsReducers.authenticating,
        globeName: store.cmsReducers.globeName,
        username: store.cmsReducers.username,
        appState: store.cmsReducers.appState,

    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(CmsActions, dispatch)
});
module.exports = connect(mapStateToProps)(withStyles(styles)(Dashboard));*/
export default Dashboard;